<template>
    <div>
        <v-dialog v-model="openDialog" persistent>
            <v-card>
                <v-card-title>
                {{ formTitle }}
                </v-card-title>
                <v-divider></v-divider>
                <flash-message></flash-message>
                <v-divider></v-divider>
                <v-card-text>
                <v-container>
                <ValidationObserver ref="observer">
                    <form>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <ValidationProvider v-slot="{ errors }" name="Descrição" rules="required|max:255">
                                    <v-text-field label="Descrição" v-model="frmItem.description"
                                    prepend-icon="mdi-card-text" required :error-messages="errors"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <ValidationProvider v-slot="{ errors }" name="Path" rules="max:255">
                                    <v-text-field label="Path" v-model="frmItem.path"
                                    prepend-icon="mdi-folder" :error-messages="errors"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="6" sm="4" md="2">
                            <header>Permissão</header>
                            <v-switch v-model="frmItem.permission"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Upload</header>
                            <v-switch v-model="frmItem.upload"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Criar</header>
                            <v-switch v-model="frmItem.add"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Renomear</header>
                            <v-switch v-model="frmItem.rename"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Excluir</header>
                            <v-switch v-model="frmItem.delete"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Ativa</header>
                            <v-switch v-model="frmItem.active"></v-switch>
                        </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <ValidationProvider v-slot="{ errors }" name="Tipo" rules="required">
                                <v-select :no-data-text="noDataAvailable" label="Tipo" v-model="frmItem.typeRule"
                                :items="allTypeRules" item-text="value" item-value="id" v-on:change="clearRuleConfigs"
                                :error-messages="errors" required>
                                </v-select>
                            </ValidationProvider>
                        </v-col>
                          <v-col cols="12" sm="6" md="6">
                          <ValidationProvider v-slot="{ errors }" name="Grupo" rules="required">
                            <v-select :no-data-text="noDataAvailable" label="Grupo" v-model="frmItem.ruleDriveGroup.id"
                                      :items="ruleGroups" item-text="name" item-value="id" v-on:change="clearRuleConfigs"
                                      :error-messages="errors" required>
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                        </v-row>
                        <v-row v-if="isBackoffice()">
                          <v-col cols="12">
                            <v-text-field label="Valor" v-model="frmItem.accessJson"
                                          prepend-icon="mdi-account-check" :error-messages="errors"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-dialog v-model="dialogSearch" scrollable max-width="500px">
                                <template v-slot:activator="{ on }">
                                <v-btn class="ma-2" color="primary" v-on="on" v-show="frmItem.typeRule">
                                    <v-icon>mdi-account-search</v-icon> <span v-text="`Buscar e vincular ${getTypeRuleDescription(frmItem.typeRule)} específico`"></span>
                                </v-btn>
                                </template>
                                <v-card>
                                <v-card-title>
                                    <v-text-field
                                    v-model="searchDialogSearch"
                                    append-icon="mdi-account-search"
                                    :label="`Pesquise pelo ${getTypeRuleDescription(frmItem.typeRule)}`"
                                    single-line
                                    hide-details
                                    @keyup="searchDialogSearchChange"
                                    ></v-text-field>
                                </v-card-title>
                                <v-card-text style="height: 400px;">
                                    <v-data-table
                                      v-show="frmItem.typeRule == 'PROFILE'"
                                      sort-by="description"
                                      :headers="headersSearch"
                                      :items="allProfiles"
                                      :search="searchDialogSearch"
                                      :footer-props="{
                                          'items-per-page-options': [5]
                                      }"
                                      item-key="id"
                                      show-select
                                      v-model="selectedDialogSearch"
                                      no-results-text="Nenhum resultado"
                                      no-data-text="Nenhum item encontrado"
                                      loading-text="Carregando"
                                      :loading="loadingSearchData"
                                    >
                                    </v-data-table>
                                    <v-data-table
                                      v-show="frmItem.typeRule == 'USER'"
                                      sort-by="description"
                                      :headers="headersSearch"
                                      :items="searchedUsers"
                                      :footer-props="{
                                          'items-per-page-options': [5]
                                      }"
                                      item-key="id"
                                      show-select
                                      disable-sort
                                      v-model="selectedDialogSearch"
                                      no-results-text="Nenhum resultado"
                                      no-data-text="Nenhum item encontrado"
                                      loading-text="Carregando"
                                      :loading="loadingSearchData"
                                      :options.sync="searchPagination"
                                      :server-items-length.sync="searchPagination.totalItems"
                                      @update:page="searchDialogUpdatePage"
                                    >
                                    </v-data-table>
                                    <v-data-table
                                      v-show="frmItem.typeRule == 'USER_GROUP'"
                                      sort-by="description"
                                      :headers="headersSearch"
                                      :items="searchedUserGroups"
                                      :search="searchDialogSearch"
                                      disable-pagination
                                      disable-sort
                                      hide-default-header
                                      hide-default-footer
                                      item-key="id"
                                      show-select
                                      v-model="selectedDialogSearch"
                                      no-results-text="Nenhum resultado"
                                      no-data-text="Nenhum item encontrado"
                                    >
                                    </v-data-table>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="buttonTextColor" text @click="btnCancelDialogSearch">Cancelar</v-btn>
                                    <v-btn color="buttonTextColor" text @click="btnSelectDialogSearch">Vincular</v-btn>
                                </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                        <v-row v-if="!isBackoffice()">
                            <v-col cols="12" sm="12" md="12">
                              <tableRuleConfigs v-bind:rule="frmItem" v-bind:viewOnly="false" @deleteItem="deleteTableRuleConfig" />
                            </v-col>
                        </v-row>
                    </form>
                </ValidationObserver>
                </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="buttonTextColor" text @click="close">Cancelar</v-btn>
                    <v-btn color="buttonTextColor" text @click="save">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { required, max } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';
import tableRuleConfigs from '@/components/table-rule-configs/index.vue';
import RulesService from '../../service/RulesService';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio',
});

extend('max', {
  ...max,
  message: '{_field_} não pode ter mais do que {length} characteres',
});

export default {
  name: 'DialogItem',
  components: {
    ValidationProvider,
    ValidationObserver,
    tableRuleConfigs,
  },
  props: {
    open: Boolean,
    allTypeRules: Array,
    ruleGroups: Array,
    userRole: String,
    editedItem: {},
    editing: Boolean,
  },

  data: () => ({
    dialogSearch: false,
    searchDialogSearch: '',
    selectedDialogSearch: [],
    headersSearch: [
      { text: 'Descrição', value: 'description' },
    ],
    defaultItem: {
      description: '',
      path: '',
      permission: true,
    },
    frmItem: {},
    openDialog: false,
    allProfiles: [],
    searchedUsers: [],
    searchedUserGroups: [],
    loadingSearchData: false,
    searchPagination: {
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
    },
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  computed: {
    formTitle() {
      return !this.editing ? 'Nova regra' : 'Editar regra';
    },
  },

  watch: {
    open() {
      this.openDialog = this.open;
    },
    editedItem() {
      this.frmItem = { ...this.editedItem };
    },
    dialogSearch() {
      if (this.dialogSearch) {
        this.inicializeDialogSearch();
      }
    },
  },

  methods: {
    isBackoffice() {
      // eslint-disable-next-line eqeqeq
      return this.userRole == 'BACKOFFICE';
    },
    clearRuleConfigs() {
      this.frmItem.ruleConfigs = [];
    },

    close() {
      this.$refs.observer.reset();
      this.$emit('closeDialogItem');
    },

    save() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit('saveDialogItem', this.frmItem);
          this.$refs.observer.reset();
        }
      });
    },

    getTypeRuleDescription(typeRule) {
      let ruleDescription = '';
      this.allTypeRules.forEach((tr) => {
        if (tr.id === typeRule) {
          ruleDescription = tr.value;
        }
      });
      return ruleDescription;
    },

    btnCancelDialogSearch() {
      this.selectedDialogSearch = [];
      this.dialogSearch = false;
    },

    btnSelectDialogSearch() {
      if (!this.frmItem.ruleConfigs) {
        this.frmItem.ruleConfigs = [];
      }
      if (this.selectedDialogSearch && this.selectedDialogSearch.length && this.selectedDialogSearch.length > 0) {
        const self = this;
        this.selectedDialogSearch.forEach((el) => {
          if (!self.frmItem.ruleConfigs.find((rc) => rc.idEntityTypeRule === el.id)) {
            self.frmItem.ruleConfigs.push({
              idEntityTypeRule: el.id,
              descriptionEntityTypeRule: el.description,
            });
          }
        });
      }

      this.dialogSearch = false;
      this.selectedDialogSearch = [];
    },

    deleteTableRuleConfig(item) {
      const deleteIndex = this.frmItem.ruleConfigs.findIndex((r) => r.idEntityTypeRule === item.idEntityTypeRule);
      this.frmItem.ruleConfigs.splice(deleteIndex, 1);
    },

    inicializeDialogSearch() {
      this.searchDialogSearch = '';
      this.searchPagination = {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
      };

      if (this.frmItem.typeRule === 'PROFILE') {
        this.allProfiles = [];
        this.loadingSearchData = true;
        RulesService.findAllProfiles()
          .then((ret) => {
            this.allProfiles = ret;
            this.loadingSearchData = false;
          })
          .catch(() => {
            this.loadingSearchData = false;
          });
      } else if (this.frmItem.typeRule === 'USER') {
        this.searchedUsers = [];
        this.loadUsersPageSearchDialog();
      }
    },

    searchDialogUpdatePage() {
      this.loadUsersPageSearchDialog();
    },

    loadUsersPageSearchDialog(newPage) {
      if (newPage) {
        this.searchPagination.page = newPage;
      }

      this.loadingSearchData = true;

      const paramsPage = new URLSearchParams();
      paramsPage.append('page', this.searchPagination.page - 1);
      paramsPage.append('size', this.searchPagination.rowsPerPage);
      paramsPage.append('sort', 'login');

      RulesService.findUserByTerm(this.searchDialogSearch, paramsPage)
        .then((ret) => {
          this.searchedUsers = ret.content;
          this.searchPagination = ret.searchPagination;
          this.loadingSearchData = false;
        })
        .catch(() => {
          this.loadingSearchData = false;
        });
    },

    searchDialogSearchChange() {
      if (this.frmItem.typeRule === 'USER') {
        const actualValueTerm = this.searchDialogSearch;
        const delay = (ms) => new Promise((res) => setTimeout(res, ms));
        const loadBeforeSeconds = async (term, self) => {
          await delay(4000);
          if (term === self.searchDialogSearch) {
            self.loadUsersPageSearchDialog(1);
          }
        };
        loadBeforeSeconds(actualValueTerm, this);
      }
    },

  },
};
</script>
